import { Card, Row, Col, Input, message, Tree, Button, Modal, Space, Form, Switch, Checkbox, Select, Radio } from "antd";
import React, { useEffect, useState } from "react";
// import { Icon } from "@iconify/react";
import { ProfileFilled } from "@ant-design/icons";
import type { DataNode, TreeProps } from "antd/es/tree";
import { v4 as uuidv4 } from "uuid";
import { OaOrganizeService } from "./service/service";
import { useId24 } from "./../../drivers/id24/Id24-provider";
import { loadAppConfig } from "./../../config/app-config";
const appConfig = loadAppConfig();

export interface Props {
  userId: string;
}

export const OaOrganize: React.FC<Props> = ({ userId }) => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isClosemodal, setClosemodal] = useState(false);
  const [oaId, setOaId] = useState("");
  const [showLine, setShowLine] = useState<boolean | { showLeafIcon: boolean }>(true);
  const [parentId, setParentId] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [name, setName] = useState("");
  const [selectKey, setSelectKey] = useState(false);
  const [pos, setPos] = useState(0);
  const [data, setData] = useState<any>([]);
  const { tokenAccess, login, logout, id24Axios } = useId24();
  const apiBaseUrlUser = id24Axios(appConfig.apiBaseUrlUser);

  useEffect(() => {
    async function fetchDataForSearch() {
      const res: any = await OaOrganizeService(apiBaseUrlUser).getOaOrganize();
      setOaId(res[0].key);
      setData(res);
    }
    fetchDataForSearch();
  }, [loadData]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const onFinish = async (values: any) => {
    const create = {
      key: values.id,
      title: values.name,
      oaId: oaId,
      parentId: parentId,
    };
    setLoadData(true);
    const res: any = await OaOrganizeService(apiBaseUrlUser).createOaOrganize(create);
    res.error ? error(res.error) : success(res.success);
    setLoadData(false);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    // console.log("Failed:", errorInfo);
  };

  const getParentTitle = (key: any, tree: any): any => {
    let parentTitle;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item: any) => item.key === key)) {
          parentTitle = node.title;
        } else if (getParentTitle(key, node.children)) {
          parentTitle = getParentTitle(key, node.children);
        }
      }
    }
    return parentTitle;
  };

  const onSelect: TreeProps["onSelect"] = async (selectedKeys: any, info: any) => {
    const pos = info.node.pos.split("-");
    // console.log(selectedKeys);
    setPos(pos.length);
    // console.log(info);
    await setParentId(info.node.key);
    await setName(info.node.title);
    selectedKeys.length == 0 ? setSelectKey(true) : setSelectKey(false);
  };

  const deleteOaOrganize = async () => {
    setLoadData(true);
    const res: any = await OaOrganizeService(apiBaseUrlUser).deleteOaOrganize(parentId, String(oaId));
    res.message ? error(res.message) : message.success("Delete Success");
    setParentId("");
    setName("");
    setSelectKey(Boolean);
    setOaId("");
    setLoadData(false);
    form.resetFields();
  };

  const success = (msg: string) => {
    message.success("Add Success");
  };

  const error = (err: string) => {
    message.error(err);
  };

  return (
    <React.Fragment>
      <Row>
        <Card style={{ width: "100%", textAlign: "left" }}>
          <b style={{ color: "#0056B4", fontSize: "24px" }}>
            {" "}
            <ProfileFilled style={{ width: 36, height: 36, color: "#0056B4" }} />
            OA Organize
          </b>
        </Card>
      </Row>

      <Row
        gutter={[
          { xs: 8, sm: 16 },
          { xs: 8, sm: 16 },
        ]}
        style={{ marginTop: "2rem" }}
      >
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Card>
            <>
              <Modal
                title="Add OA Organize"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                  <Button form="formfield" type="primary" htmlType="submit" onClick={handleOk}>
                    Submit
                  </Button>,
                ]}
              >
                <Form
                  form={form}
                  id="formfield"
                  name="basic"
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 14 }}
                  initialValues={{ oaId: oaId }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  fields={[
                    {
                      name: ["id"],
                      value: uuidv4(),
                    },
                  ]}
                >
                  <Form.Item label="ID" name="id" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Name" name="name">
                    <Input />
                  </Form.Item>
                  <Form.Item label="OA" name="OA" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item label="oaId" name="oaId" hidden>
                    <Input />
                  </Form.Item>
                </Form>
              </Modal>
            </>
            <Row style={{ marginLeft: 100 }}>
              <Col span="12">
                <Tree
                  showLine={showLine}
                  defaultExpandedKeys={["0-0-0", "0-0-1"]}
                  defaultSelectedKeys={["0-0-0", "0-0-1"]}
                  defaultCheckedKeys={["0-0-0", "0-0-1"]}
                  onSelect={onSelect}
                  treeData={data}
                />
              </Col>
              <Col span="12">
                <Space>
                  <Button
                    type="primary"
                    onClick={showModal}
                    disabled={name || parentId ? (parentId === oaId || selectKey || pos > 4 ? true : false) : true}
                  >
                    + Add OA OaOrganize
                  </Button>
                  <Button
                    type="primary"
                    danger
                    disabled={name || parentId ? (parentId === oaId || selectKey ? true : false) : true}
                    onClick={deleteOaOrganize}
                  >
                    Delete OaOrganize
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};
